import {
    URLAPI,
    REASON_MAINTENANCE_PATH,
    REASON_MAINTENANCE_CREATE_PATH,
    REASON_MAINTENANCE_UPDATE_PATH,
    REASON_MAINTENANCE_DELETE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_reason_maintenance: {
        data: [],

        status: 0,
        message: {},
    },

    _create_reason_maintenance: {
        data: {},
        status: 0,
        message: {},
    },
    _update_reason_maintenance: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_reason_maintenance: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_REASON_MAINTENANCE = "GET_ALL_REASON_MAINTENANCE";
export const CREATE_REASON_MAINTENANCE = "CREATE_REASON_MAINTENANCE";
export const UPDATE_REASON_MAINTENANCE = "UPDATE_REASON_MAINTENANCE";
export const DELETE_REASON_MAINTENANCE = "DELETE_REASON_MAINTENANCE";

export const reason_maintenance_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_REASON_MAINTENANCE:
            return {
                ...state,
                _get_all_reason_maintenance: action.payload,
            };
        case CREATE_REASON_MAINTENANCE:
            return {
                ...state,
                _create_reason_maintenance: action.payload,
            };
        case UPDATE_REASON_MAINTENANCE:
            return {
                ...state,
                _update_reason_maintenance: action.payload,
            };
        case DELETE_REASON_MAINTENANCE:
            return {
                ...state,
                _delete_reason_maintenance: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllReasonMaintenance = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${REASON_MAINTENANCE_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_REASON_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_REASON_MAINTENANCE,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_REASON_MAINTENANCE,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createReasonMaintenance = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${REASON_MAINTENANCE_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_REASON_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_REASON_MAINTENANCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_REASON_MAINTENANCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateReasonMaintenance = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${REASON_MAINTENANCE_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_REASON_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_REASON_MAINTENANCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_REASON_MAINTENANCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteReasonMaintenance = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(
            `${URLAPI}${REASON_MAINTENANCE_DELETE_PATH}${id}/`,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_REASON_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_REASON_MAINTENANCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_REASON_MAINTENANCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_reason_maintenance = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
